import { Typography, YStack } from '@shinetools/lumen-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import type { Contact } from '@features/contacts/types/contact'
import { getPostalAddressLines } from '@features/contacts/utils/getPostalAddressLines'
import { fetchCountries } from '@modules-deprecated/app/countries/query-api'

import { QueryKeys } from '../../../../../../../../enums/queryKeys'
import { getCurrentLocale } from '../../../../../../../../utils/getCurrentLocale'
import { LabelValueRow } from '../LabelValueRow'
import { getPrimaryContactNameAndEmail } from './utils/getPrimaryContactNameAndEmail'

interface CompanyInformationProps {
  contact: Contact
}

export const CompanyInformation = ({ contact }: CompanyInformationProps) => {
  const { t } = useTranslation()
  const locale = getCurrentLocale()
  const { data: countriesData } = useQuery([QueryKeys.Countries, locale], () => fetchCountries(locale))

  const addressLines = useMemo(() => getPostalAddressLines(contact), [contact])

  const countryName = contact.countryId
    ? (countriesData?.countries.find((country) => country.id === contact.countryId)?.name ?? '')
    : ''

  return (
    <YStack gap={12}>
      <Typography.Text size="large" weight="semibold">
        {t('suppliers.detail.company_information.title')}
      </Typography.Text>
      <YStack>
        <LabelValueRow label={t('suppliers.detail.company_information.label.name')} value={contact?.name} />
        <LabelValueRow label={t('suppliers.detail.company_information.label.country')} value={countryName} />
        <LabelValueRow label={t('suppliers.detail.company_information.label.tax_id')} value={contact?.vatNo} />
        <LabelValueRow label={t('suppliers.detail.company_information.label.ean')} value={contact?.ean} />
        <LabelValueRow label={t('suppliers.detail.company_information.label.address')} value={addressLines} />
        <LabelValueRow label={t('suppliers.detail.company_information.label.phone_number')} value={contact?.phone} />
        <LabelValueRow
          label={t('suppliers.detail.company_information.label.contact')}
          value={getPrimaryContactNameAndEmail(contact)}
        />
      </YStack>
    </YStack>
  )
}
